import random from 'lodash/random'
import { combineReducers } from 'redux'

import { persistToStorage } from '../../utils/storage'
import {
  initialQuizState,
  initialLeadID,
  initialSearchModalOpenState,
} from '../initial-state'
import campusReducer from './campus'
import featureFlagReducer from './featureFlags'
import formRedirectReducer from './formRedirect'
import hiddenFormParamsReducer from './hiddenFormParams'
import personaReducer from './persona'
import programReducer from './program'

const searchModalReducer = (
  previousState = initialSearchModalOpenState,
  action,
) => {
  if (action.type === 'SHOW_SEARCH_MODAL') {
    return action.payload
  }
  return previousState
}

const leadIDReducer = (previousState = initialLeadID, action) => {
  if (action.type === 'UPDATE_LEADID') {
    return action.payload
  }
  return previousState
}

const quizReducer = (state = initialQuizState, action) => {
  const { type, payload } = action

  switch (type) {
    case 'UPDATE_NODE': {
      const { currentNode } = state
      const { id } = payload

      return {
        ...state,
        currentNode: id,
        previousNode: currentNode,
      }
    }

    case 'CREATE_QUIZ_SESSION': {
      const session = {
        answer: null,
        id: `id_${random(100, 999)}-${random(100, 999)}-${random(100, 999)}`,
        start_at: Date.now(),
        update_at: null,
      }

      const newSessions = { ...state.sessions, [session.id]: session }

      // Store the sessions object in local storage so quiz sessions are persistent
      try {
        persistToStorage('quiz-sessions', newSessions)
        persistToStorage('quiz-current-session', session)
      }
      catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }

      return {
        ...state,
        currentSession: session,
        previousSession: {},
        sessions: newSessions,
      }
    }

    case 'COMPLETE_QUIZ_SESSION': {
      const { sessions } = state
      const { id, program } = payload

      if (id === null) {
        return state
      }

      const session = sessions[id]

      const newSession = {
        ...session,
        answer: program,
        update_at: Date.now(),
      }

      const newSessions = { ...sessions, [newSession.id]: newSession }

      // Store the sessions object in local storage so quiz sessions are persistent
      try {
        persistToStorage('quiz-sessions', newSessions)
        persistToStorage('quiz-current-session', {})
      }
      catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }

      return {
        ...state,
        currentSession: {},
        previousSession: newSession,
        sessions: newSessions,
      }
    }

    default: {
      return state
    }
  }
}

const reducers = combineReducers({
  campus: campusReducer,
  displaySearchModal: searchModalReducer,
  featureFlags: featureFlagReducer,
  formRedirect: formRedirectReducer,
  hiddenFormParams: hiddenFormParamsReducer,
  leadID: leadIDReducer,
  persona: personaReducer,
  program: programReducer,
  quiz: quizReducer,
})

export default reducers
